export const uk = {
    brandlift: 'Исследования',
    'budget-limit-with-currency': 'Бюджет, {currency}',
    budgetLimit: 'Бюджет',
    'campaign-type': 'Тип кампании',
    default: 'Ручное управление',
    goals: 'Конверсии',
    id: 'Id',
    name: 'Название',
    platform: 'Места показов',
    settings: 'Настройки',
    status: 'Статус',
    strategy: 'Стратегія',
    sum: 'Осталось',
    'sum-with-currency': 'Осталось, {currency}',
    type: 'Тип'
};
